import { Component, OnInit, ViewChild } from "@angular/core";
import { confirm } from 'devextreme/ui/dialog';
import { DxDataGridComponent } from "devextreme-angular";
import { NotificationService } from "../common/component/notification/notification.service";
import { SharedService } from "../services/SharedService";
import { DistributorReferralMaintenanceService } from "./distributor-referral-maintenance.service";
import { DatePipe } from '@angular/common';

@Component({
    selector: 'distributor-referral-maintenance',
    templateUrl: './distributor-referral-maintenance.component.html',
    styleUrls: ['./distributor-referral-maintenance.component.scss']
})

export class DistributorReferralMaintenanceComponent implements OnInit {

    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    readonly allowedPageSizes = [50, 100, 200];
    isLoadPanelVisible: boolean = false;
    showGrid: boolean = false;

    distributorReferralMaintenance: any[];
    stateProvince: any[];
    postCode: string = '';
    radius: number = 25;
    disablePickMe: boolean = true;
    apexId: any;
    date: any;


    constructor(private notificationService: NotificationService, private distributorReferralMaintenanceService: DistributorReferralMaintenanceService
        , private sharedsvc: SharedService, private datepipe: DatePipe) {
        this.date = this.datepipe.transform((new Date), 'MM/dd/yyyy h:mm:ss a');

        this.isLoadPanelVisible = true;
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        
        this.distributorReferralMaintenanceService.getDistributorStates().subscribe({
            next: stateProvince => {
                this.isLoadPanelVisible = false;
                this.stateProvince = stateProvince;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching StateProvince", error);
            }
        });
    }
    ngOnInit(): void {
        this.apexId = this.sharedsvc.email.split("@")[0];

    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSorting();
    }

    addRow() {
        this.dataGrid.instance.addRow();
    }

    addDistributorReferralMaintenance(event) {
        this.isLoadPanelVisible = true;
        event.data.userPostCode = this.postCode;
        event.data.radius = this.radius;
        event.data.distributorId = 0;
        this.distributorReferralMaintenanceService.addDistributor(event.data).subscribe({
            next: (x: any) => {
                this.distributorReferralMaintenance = x;

                this.isLoadPanelVisible = false;
                this.notificationService.alert('success', 'Distributor added successfully', null);
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while adding distributor", error);
            }
        });
    }

    updateDistributorReferralMaintenance(event) {
        this.isLoadPanelVisible = true;
        event.data.userPostCode = this.postCode;
        event.data.radius = this.radius;
        this.distributorReferralMaintenanceService.updateDistributor(event.data).subscribe({
            next: (x: any) => {
                this.distributorReferralMaintenance = x;
                this.isLoadPanelVisible = false;
                this.notificationService.alert('success', 'Distributor updated successfully', null);
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while updating distributor", error);
            }
        });
    }

    onInitNewRow(event) {
        event.data.activeFlag = true;
        event.data.pickMe = false;
    }

    pickMe() {

        if (!this.postCode) {
            alert("Please enter the post code");
            return;
        }

        if (!this.radius) {
            alert("Please enter the radius");
            return;
        }

        var data = this.dataGrid.instance.getSelectedRowsData();

        const updatedData = data.map(obj => {
            return { ...obj, postCode: this.postCode };
        });

        this.isLoadPanelVisible = true;
        this.distributorReferralMaintenanceService.pickMe(updatedData).subscribe({
            next: (x: any) => {

                this.isLoadPanelVisible = false;
                this.notificationService.alert('success', 'Saved successfully', null);
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while saving", error);
            }
        });
    }

    onSaveClick(e) {
        this.dataGrid.instance.saveEditData();
    }

    onCancelClick(e) {
        let that = this;
        var result = confirm("Your changes will be lost. Are you sure?", "Confirm");
        result.then(function (dialogResult) {
            if (dialogResult) {
                that.dataGrid.instance.cancelEditData();
            }
        });

    }

    selectionChangedHandler() {
        this.disablePickMe = this.dataGrid.selectedRowKeys.length < 1;
    }

    search(event) {
        if (event.validationGroup.validate().isValid) {
            this.isLoadPanelVisible = true;
            this.showGrid = false;
            this.distributorReferralMaintenanceService.getDistributors(this.postCode, this.radius).subscribe({
                next: distributorReferralMaintenance => {
                    this.distributorReferralMaintenance = distributorReferralMaintenance;
                    this.isLoadPanelVisible = false;
                    this.showGrid = true;
                }, error: (error) => {
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("error", "Error while fetching Distributors", error);
                }
            });
        }
    }

}